// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__LRjFz","normalXl":"styles_normalXl__S+JS6","normalLg":"styles_normalLg__NpWYe","normalMd":"styles_normalMd__4G-fI","normalSm":"styles_normalSm__BaymX"};